import State from '@/helpers/pattern/state';
import {ComercioModel} from "@/models/generales/comercio";
import {modelIsModified} from "@/helpers/vue-mc";
import {EventBus} from '@/events/event-bus';
import * as events from '@/constants/event-names';
import ComercioAPI from "@/services/generales/comercio";
import {scrollToForm} from '@/helpers/form-scroll-to';


/**
 * State Pattern for Comercio form
 */
export default class ComercioStates extends State{
  /**
   * Class constructor, important pass the required data within the states methods
   * @param {*} data Any type of data that you want available within the states methods
   */
  constructor(data){
    super(data);
  }

  /**
   * General Methods
   */
  base(){
    return {
      clear({$setState}){
        $setState('initial');
      }
      , async askForClear({$data}){
        try{
          const response = await $data.$swal({
            title: $data.$t('view.global.swal.clear.title')
            , text: $data.$t('view.global.swal.clear.text')
            , type: $data.$t('view.global.swal.clear.type')
            , showCancelButton: $data.$t('view.global.swal.clear.showCancelButton')
            , confirmButtonColor: $data.$t('view.global.swal.clear.confirmButtonColor')
            , cancelButtonColor: $data.$t('view.global.swal.clear.cancelButtonColor')
            , confirmButtonText: $data.$t('view.global.swal.clear.confirmButtonText')
            , cancelButtonText: $data.$t('view.global.swal.clear.cancelButtonText')
            , reverseButtons: true
          });
          
          if(response.value){
            this.clear();
          }
          
          return;
        }catch(error){
          console.log(error)
        }
      }
      , async audit(
        {$data}
        , {
          clave , name, email, tipoArchivo, status
          , urlBuzonEntrada, usuarioBuzonEntrada, passwordBuzonEntrada
          // , urlBuzonRecepcion, usuarioBuzonRecepcion, passwordBuzonRecepcion
          , puertoBuzonEntrada
          // , puertoBuzonRecepcion
          , locationAddress
          , locationCity
          , locationRegionCode
          , locationCountryCode
          , locationPostalCode
          , consecutivoArchivosGenerados
          , numeroComercio
          , formatoRespueta
          , contenidoRespuesta
          , summitterId
          , nombreArchivo
          , nombreArchivoGSFG
          , nombreArchivoRespuesta
          , tiempoMaximoEsperaRespuesta
          , esperaRespuesta
          , fechaFinEsperaRespuesta
          , fechaFinAdvertenciaRespuesta
          , tiempoMaximoAdvertenciaRespuesta
          , mcc
          , multipleSucursal
          , sucursalEnEspera
          , nombreArchivoCartRefresh
          , nombreArchivoCartRefreshCarga
          , enviarCorreoSFTP
          
        }
      ){
        try{
          auditoriaStates.EditingState({
            clave , name, email, tipoArchivo, status
            , urlBuzonEntrada, usuarioBuzonEntrada, passwordBuzonEntrada
            // , urlBuzonRecepcion, usuarioBuzonRecepcion, passwordBuzonRecepcion
            , puertoBuzonEntrada
            // , puertoBuzonRecepcion
            , locationAddress
            , locationCity
            , locationRegionCode
            , locationCountryCode
            , locationPostalCode
            , consecutivoArchivosGenerados
            , numeroComercio
            , formatoRespueta
            , contenidoRespuesta
            , summitterId
            , nombreArchivo
            , nombreArchivoGSFG
            , nombreArchivoRespuesta
            , tiempoMaximoEsperaRespuesta
            , esperaRespuesta
            , fechaFinEsperaRespuesta
            , fechaFinAdvertenciaRespuesta
            , tiempoMaximoAdvertenciaRespuesta
            , mcc
            , multipleSucursal
            , sucursalEnEspera
            , nombreArchivoCartRefresh
            , nombreArchivoCartRefreshCarga
            , enviarCorreoSFTP
          });
        }catch(error){
          console.log(error)
        }
      }
      , resetModel({$data}){
        $data.comercio = new ComercioModel();
      }
      , resetValidators({$data}){
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({$data}){
        return $data.hasErrors($data.$v.comercio) || $data.view.action.submit.busy;
      }
      , async load({$data,$setState},{clave}){
        try{
          EventBus.$emit(events.LOADING,$data.view.action.submit.busy=true);
          const response = await ComercioAPI.get({clave:clave});
          scrollToForm($data);
          return response
        }catch(error){
          console.log(error);
        }finally{
          EventBus.$emit(events.LOADING,$data.view.action.submit.busy=false);
        }
      }
      , async unlock({$data},{clave}){
        try{
          EventBus.$emit(events.LOADING,$data.view.action.submit.busy=true);
          const response = await ComercioAPI.unlock({clave:clave});
          $data.$refs.comercioTable.refreshData();
          return response
        }catch(error){
          console.log(error);
        }finally{
          EventBus.$emit(events.LOADING,$data.view.action.submit.busy=false);
        }
      }
      , async adelantarEsperaRespuesta({$data},{clave}){
        try{
         
          EventBus.$emit(events.LOADING,$data.view.action.submit.busy=true);
          const response = await ComercioAPI.adelantarEsperaRespuesta({clave:clave});
          $data.$refs.comercioTable.refreshData();
          return response
        }catch(error){
          console.log(error);
        }finally{
          EventBus.$emit(events.LOADING,$data.view.action.submit.busy=false);
        }
      }
      , async cambiarFechaEsperaRespuesta({$data},{clave}){
        try{
          
          EventBus.$emit(events.LOADING,$data.view.action.submit.busy=true);
          const response = await ComercioAPI.cambiarFechaEsperaRespuesta({clave:clave});
          $data.$refs.comercioTable.refreshData();
          return response
        }catch(error){
          console.log(error);
        }finally{
          EventBus.$emit(events.LOADING,$data.view.action.submit.busy=false);
        }
      }
    }
  }

  /**
   * States and its methods
   */
  states(){
    return{
      initial:{
        $constructor:function({$data}){
            //Reset Models and validators
            this.resetModel();
            this.resetValidators();
            //View configuration
            $data.view.elem.button.clear.visible=true;
            $data.view.elem.button.audit.visible=false;
            $data.view.elem.input.clave.visible=false;
            $data.view.elem.input.clave.disabled=true;
            $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.save;
            $data.view.elem.button.submit.data.title.current = $data.view.elem.button.submit.data.title.save;
            $data.view.elem.button.submit.permission = 'ROLE_AGREGAR_COMERCIO';
            
            
        }
        , async submit({$data},{
          clave , name, email, tipoArchivo, status
          , urlBuzonEntrada, usuarioBuzonEntrada, passwordBuzonEntrada
          // , urlBuzonRecepcion, usuarioBuzonRecepcion, passwordBuzonRecepcion
          , puertoBuzonEntrada
          // , puertoBuzonRecepcion
          , locationAddress
          , locationCity
          , locationRegionCode
          , locationCountryCode
          , locationPostalCode
          , consecutivoArchivosGenerados
          , numeroComercio
          , formatoRespueta
          , contenidoRespuesta
          , summitterId
          , nombreArchivo
          , nombreArchivoGSFG
          , nombreArchivoRespuesta
          , tiempoMaximoEsperaRespuesta
          , esperaRespuesta
          , fechaFinEsperaRespuesta
          , fechaFinAdvertenciaRespuesta
          , tiempoMaximoAdvertenciaRespuesta
          , mcc
          , multipleSucursal
          , sucursalEnEspera
          , nombreArchivoCartRefresh
          , nombreArchivoCartRefreshCarga
          , enviarCorreoSFTP
        }){
          try{
            if(!$data.isAllValid($data.$v)){
              scrollToForm($data);
              return false;
            }
            $data.view.action.submit.busy=true;
            EventBus.$emit(events.LOADING,$data.view.action.submit.busy);
            const response = await ComercioAPI.save({clave:null, name, email, tipoArchivo, status
              , urlBuzonEntrada, usuarioBuzonEntrada, passwordBuzonEntrada
              // , urlBuzonRecepcion, usuarioBuzonRecepcion, passwordBuzonRecepcion
              , puertoBuzonEntrada
              // , puertoBuzonRecepcion
              , locationAddress
              , locationCity
              , locationRegionCode
              , locationCountryCode
              , locationPostalCode
              , consecutivoArchivosGenerados
              , numeroComercio
              , formatoRespueta
              , contenidoRespuesta
              , summitterId
              , nombreArchivo
              , nombreArchivoGSFG
              , nombreArchivoRespuesta
              , tiempoMaximoEsperaRespuesta
              , esperaRespuesta
              , fechaFinEsperaRespuesta
              , fechaFinAdvertenciaRespuesta
              , tiempoMaximoAdvertenciaRespuesta
              , mcc
              , multipleSucursal
              , sucursalEnEspera
              , nombreArchivoCartRefresh
              , nombreArchivoCartRefreshCarga
              , enviarCorreoSFTP
            });
            $data.view.action.submit.busy=false;
            this.resetModel();
            this.resetValidators();
            $data.$refs.comercioTable.refreshData();
            return response;
          }catch(error){
            console.log(error)
            return error;
          }finally{
            $data.view.action.submit.busy=false;
            EventBus.$emit(events.LOADING,$data.view.action.submit.busy);
          }
        }
        
      }
      , editing:{
        $constructor:function({$data}, comercio){
          
          const {
            clave , name, email, tipoArchivo, status
            , urlBuzonEntrada, usuarioBuzonEntrada, passwordBuzonEntrada
            // , urlBuzonRecepcion, usuarioBuzonRecepcion, passwordBuzonRecepcion
            , puertoBuzonEntrada
            // , puertoBuzonRecepcion
            , locationAddress
            , locationCity
            , locationRegionCode
            , locationCountryCode
            , locationPostalCode
            , consecutivoArchivosGenerados
            , numeroComercio
            , formatoRespueta
            , contenidoRespuesta
            , summitterId
            , nombreArchivo
            , nombreArchivoGSFG
            , nombreArchivoRespuesta
            , tiempoMaximoEsperaRespuesta
            , esperaRespuesta
            , fechaFinEsperaRespuesta
            , fechaFinAdvertenciaRespuesta
            , tiempoMaximoAdvertenciaRespuesta
            , mcc
            , multipleSucursal
            , sucursalEnEspera
            , nombreArchivoCartRefresh
            , nombreArchivoCartRefreshCarga
            , enviarCorreoSFTP
          } = comercio;
          $data.view.elem.button.clear.visible=true;
          $data.view.elem.button.audit.visible=true;
          $data.view.elem.input.clave.visible=true;
          $data.view.elem.input.clave.disabled=true;
          $data.view.elem.button.submit.class.current = $data.view.elem.button.submit.class.update;
          $data.view.elem.button.submit.data.title.current = $data.view.elem.button.submit.data.title.update;
          $data.view.elem.button.submit.permission = 'ROLE_MODIFICAR_COMERCIO';
          $data.comercio = new ComercioModel({
            clave , name, email, tipoArchivo, status
            , urlBuzonEntrada, usuarioBuzonEntrada, passwordBuzonEntrada
            // , urlBuzonRecepcion, usuarioBuzonRecepcion, passwordBuzonRecepcion
            , puertoBuzonEntrada
            // , puertoBuzonRecepcion
            , locationAddress
            , locationCity
            , locationRegionCode
            , locationCountryCode
            , locationPostalCode
            , consecutivoArchivosGenerados
            , numeroComercio
            , formatoRespueta
            , contenidoRespuesta
            , summitterId
            , nombreArchivo
            , nombreArchivoGSFG
            , nombreArchivoRespuesta
            , tiempoMaximoEsperaRespuesta
            , esperaRespuesta
            , fechaFinEsperaRespuesta
            , fechaFinAdvertenciaRespuesta
            , tiempoMaximoAdvertenciaRespuesta
            , mcc
            , multipleSucursal
            , sucursalEnEspera
            , nombreArchivoCartRefresh
            , nombreArchivoCartRefreshCarga
            , enviarCorreoSFTP
          });
          this.resetValidators();
        }
        , async submit({$data, $setState}, comercio){
          const {
            clave , name, email, tipoArchivo, status
            , urlBuzonEntrada, usuarioBuzonEntrada, passwordBuzonEntrada
            // , urlBuzonRecepcion, usuarioBuzonRecepcion, passwordBuzonRecepcion
            , puertoBuzonEntrada
            // , puertoBuzonRecepcion
            , locationAddress
            , locationCity
            , locationRegionCode
            , locationCountryCode
            , locationPostalCode
            , consecutivoArchivosGenerados
            , numeroComercio
            , formatoRespueta
            , contenidoRespuesta
            , summitterId
            , nombreArchivo
            , nombreArchivoGSFG
            , nombreArchivoRespuesta
            , tiempoMaximoEsperaRespuesta
            , esperaRespuesta
            , fechaFinEsperaRespuesta
            , fechaFinAdvertenciaRespuesta
            , tiempoMaximoAdvertenciaRespuesta
            , mcc
            , multipleSucursal
            , sucursalEnEspera
            , nombreArchivoCartRefresh
            , nombreArchivoCartRefreshCarga
            , enviarCorreoSFTP
          }=comercio;
          try{
            if(!$data.isAllValid($data.$v)){
              scrollToForm($data)
              return false;
            }
            $data.view.action.submit.busy=true;
            EventBus.$emit(events.LOADING,$data.view.action.submit.busy);
            const response = await ComercioAPI.update({
              clave , name, email, tipoArchivo, status
              , urlBuzonEntrada, usuarioBuzonEntrada, passwordBuzonEntrada
              // , urlBuzonRecepcion, usuarioBuzonRecepcion, passwordBuzonRecepcion
              , puertoBuzonEntrada
              // , puertoBuzonRecepcion
              , locationAddress
              , locationCity
              , locationRegionCode
              , locationCountryCode
              , locationPostalCode
              , consecutivoArchivosGenerados
              , numeroComercio
              , formatoRespueta
              , contenidoRespuesta
              , summitterId
              , nombreArchivo
              , nombreArchivoGSFG
              , nombreArchivoRespuesta
              , tiempoMaximoEsperaRespuesta
              , esperaRespuesta
              , fechaFinEsperaRespuesta
              , fechaFinAdvertenciaRespuesta
              , tiempoMaximoAdvertenciaRespuesta
              , mcc
              , multipleSucursal
              , sucursalEnEspera
              , nombreArchivoCartRefresh
              , nombreArchivoCartRefreshCarga
              , enviarCorreoSFTP
            });
            $data.$refs.comercioTable.refreshData();
            $data.view.action.submit.busy=false;
            $setState('initial')
            //Object.setPrototypeOf($data.state, new InitialState($data));
            return response;
          }catch(error){
            console.log(error)
            return error;
          }finally{
            $data.view.action.submit.busy=false;
            EventBus.$emit(events.LOADING,$data.view.action.submit.busy);
          }
        }
        , isDisableButtonSubmit({$data}){
          return $data.hasErrors($data.$v.comercio) 
            || $data.view.action.submit.busy
            || !modelIsModified($data.comercio)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/generales/comercio/comercio-states.js